import { Component, Input, OnInit } from '@angular/core';
import { getPrettyZCStatus } from 'src/app/shared/enums/zoning-code-status';
import IStatisticByStatus = ZoningAPI.IStatisticByStatus;

@Component({
    standalone: false,
    selector: 'app-zoning-code-statuses-list',
    templateUrl: './zoning-code-statuses-list.component.html',
    styleUrls: ['./zoning-code-statuses-list.component.scss']
})
export class ZoningCodeStatusesListComponent implements OnInit {
    @Input()
    statistic: IStatisticByStatus[] = [];

    getPrettyZCStatus = getPrettyZCStatus;

    constructor() {}

    ngOnInit(): void {}
}
